import Manifest from '../core/manifest'
import Utils from '../utils/utils'

/**
 * Реальное качество для плашек на карточках.
 *
 * На карточке CUB рисует тип релиза (WEBDL / TS / CAMRip). Мы поверх показываем
 * то разрешение, которое реально спарсили с Filmix и держим в реестре — то есть
 * то, что зритель действительно получит, нажав play.
 *
 * Карточек на экране десятки, поэтому запрашиваем ПАЧКОЙ: карточка кладёт свой
 * tmdb id в очередь, через BATCH_MS уходит один запрос на все накопленные.
 * Ответы держим в памяти — лента прокручивается туда-сюда, повторно не спрашиваем.
 * Нет записи в реестре (фильма нет на Filmix или его ещё не прогрели) — молчим,
 * плашка остаётся такой, какой её нарисовал CUB.
 *
 * У фильмов и сериалов TMDB id пересекаются, поэтому ключ — тип вместе с id ('tv1396').
 */

const BATCH_MS = 120          // окно накопления id перед запросом
const BATCH_MAX = 100         // столько id влезает в один запрос (бэк режет по 200)
const CACHE_LIMIT = 3000      // потолок карты ответов, чтобы не течь на длинных сессиях

let API_BASE = ''
let known = {}                // ключ -> качество (число) | 0, если у нас нет
let known_count = 0
let queue = []                // ключи, ожидающие запроса: {key, type, id}
let waiting = {}              // ключ -> [колбэки]
let timer = null

function label(quality){
    return quality >= 2160 ? '4K' : quality >= 1440 ? '2K' : quality + 'p'
}

function remember(key, quality){
    if(known_count > CACHE_LIMIT){ known = {}; known_count = 0 }
    if(known[key] === undefined) known_count++

    known[key] = quality
}

function idsOf(items, type){
    return items.filter((item)=> item.type == type).map((item)=> item.id).join(',')
}

function flush(){
    timer = null

    let items = queue.splice(0, BATCH_MAX)
    if(!items.length) return
    if(queue.length) timer = setTimeout(flush, BATCH_MS)

    let xhr = new XMLHttpRequest()

    xhr.open('GET', API_BASE + '?movie=' + idsOf(items, 'movie') + '&tv=' + idsOf(items, 'tv'), true)
    xhr.timeout = 8000

    xhr.onload = ()=>{
        let data = {}

        try { data = JSON.parse(xhr.responseText) || {} } catch(e){}

        items.forEach((item)=>{
            let quality = parseInt((data[item.type] || {})[item.id]) || 0

            remember(item.key, quality)

            let calls = waiting[item.key] || []

            delete waiting[item.key]

            if(quality) calls.forEach((call)=> call(quality, label(quality)))
        })
    }

    // Ошибка/таймаут — просто забываем ожидающих: плашка остаётся от CUB.
    xhr.onerror = xhr.ontimeout = ()=>{ items.forEach((item)=> { delete waiting[item.key] }) }

    xhr.send()
}

/**
 * Узнать качество для карточки. Колбэк зовётся ТОЛЬКО когда качество у нас есть
 * (синхронно, если уже в памяти), иначе не зовётся вовсе.
 * @param {object} data - карточка
 * @param {function} call - (quality:number, text:string)
 */
function get(data, call){
    // id карточки = tmdb только для источников cub/tmdb, иначе он свой
    // (напр. кинопоиск) и настоящий лежит отдельным полем.
    let id   = parseInt(['cub','tmdb'].indexOf(data.source || 'tmdb') == -1 ? data.tmdb_id : data.id)
    let type = data.name || data.original_name ? 'tv' : 'movie'
    let key  = type + id

    if(!API_BASE || !id) return

    if(known[key] !== undefined){
        if(known[key]) call(known[key], label(known[key]))

        return
    }

    if(waiting[key]){ waiting[key].push(call); return }

    waiting[key] = [call]
    queue.push({key, type, id})

    if(!timer) timer = setTimeout(flush, BATCH_MS)
}

function init(){
    let host = (Manifest.cub_site || '').replace(/\/+$/,'')

    if(!host) return

    API_BASE = Utils.protocol() + host + '/api/filmix/quality'
}

export default {
    init,
    get,
    label
}
